import { render, staticRenderFns } from "./site-importer-page.vue?vue&type=template&id=0f7f5c4d&"
import script from "./site-importer-page.vue?vue&type=script&lang=js&"
export * from "./site-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports